import * as React from 'react';

interface IProps {
    label: string;
    id: string;
    className?: string;
    value: string
    disabled?: boolean;
    onChange: (event: any) => void;
    inputValid?: boolean;
    validationMessage?: string;
}

export class TextInput extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <div className="form-group">
                <label htmlFor="mobile" className="font-weight-semi-bold">{this.props.label}</label>
                <div className="input-group">
                    <input
                        type="text"
                        className={this.props.className}
                        id={this.props.id}
                        value={this.props.value}
                        disabled={this.props.disabled}
                        onChange={this.props.onChange}/>
                    {this.props.inputValid === false &&
                        <div className="invalid-feedback d-block">{this.props.validationMessage}</div>
                    }
                </div>
            </div>
        )
    }
}
